import React from 'react';

import { useAutoSelectUrl } from 'features/autoselect/hooks/use-auto-select-url';
import { ActivityIndicator, StyleSheet, View } from 'react-native';

export default function AutoSelectRoute() {
  useAutoSelectUrl();

  // Show loading while the hook processes the parameters
  return (
    <View style={styles.container}>
      <ActivityIndicator size="large" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center' },
});
